module.exports = __webpack_public_path__ + "static/media/iqraSample.937b4d16.png";